<template>
    <div class="qrcode_main"  @mouseover="isShow = true" @mouseout="isShow = false">
        <div class="qrcode_main_trans">
            <div class="qrcode_main_icon" v-show="!isShow"></div>
            <div class="qrcode_main_text" v-show="isShow">加入<br>群聊</div>
        </div>
        <div class="qrcode_main_placeholder"></div>
        <div class="qrcode_main_img" v-show="isShow" >扫一扫加入官方QQ群</div>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'qrcode',
        data () {
            return {
                isShow: false
            }
        }
    }
</script>
<style lang="scss" scoped>
@import '../../scss/common/qrcode.scss';
</style>



// WEBPACK FOOTER //
// src/components/lib/qrcode.vue